<div class="book-detail">
  <div class="header-table">
    <div class="line">
      <div class="padding-broker left">CORR.</div>
      <div class="padding-number qtd">QTD.</div>
      <div class="padding-number sale">COMPRA</div>
      <div class="padding-number sale">VENDA</div>
      <div class="padding-number qtd">QTD.</div>
      <div class="padding-broker right">CORR.</div>
    </div>
  </div>
  <div id="agGrid" class="flex-column table-book align" [ngClass]="{'theory': auctionHammer}"
    *ngIf="!loadingDetailBook">
    <table class="col-12 table-striped table-hovered table-body" *ngIf="rowOffersData?.length >= 0">
      <tbody>
        <tr *ngFor="let row of rowOffersData let index=index;">
          <td class="padding-broker tooltip-cell broker-l" (mouseenter)="mouseEnterBrokerRow()"
            (mouseleave)="mouseLeaveBrokerRow()">
            <span *ngIf="!tooltiphover"
              [ngStyle]="{'margin-top' : tooltiphover ? '-12px' : '-12px'}">{{row.broker_purchase_short}}</span>
            <span *ngIf="tooltiphover" [ngStyle]="{'margin-top' : tooltiphover ? '-12px' : '-12px'}"
              matTooltipPosition="above" matTooltip="{{row.broker_purchase}}">{{row.broker_purchase_short}}</span>
          </td>
          <td class="padding-number qtd">{{ row.qty_purchase | abbreviateNumber }}</td>
          <td class="aggressor buy cursor" (click)="openBillet('sell', row.purchase);">
            <currency-cell [price]="row.purchase" [changeBackground]="false"></currency-cell>
          </td>
          <td class="aggressor sell cursor" (click)="openBillet('buy', row.sale);">
            <currency-cell [price]="row.sale" [changeBackground]="false"></currency-cell>
          </td>
          <td class="padding-number qtd">{{ row.qty_sale | abbreviateNumber }}</td>

          <td class="padding-broker tooltip-cell borker-r" (mouseenter)="mouseEnterBrokerRow()"
            (mouseleave)="mouseLeaveBrokerRow()">
            <span *ngIf="!tooltiphover" [ngStyle]="{'margin-top' : tooltiphover ? '-12px' : '-12px'}">{{
              row.broker_sale_short }}</span>
            <span *ngIf="tooltiphover" [ngStyle]="{'margin-top' : tooltiphover ? '-12px' : '-12px'}"
              matTooltipPosition="above" matTooltip="{{row.broker_sale}}">{{ row.broker_sale_short }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
